import React from "react";
import { Modal, Button } from "react-bootstrap";
import { FiX } from "react-icons/fi";
import "./loginRequiredModal.scss";
import { useNavigate } from "react-router-dom";

const LoginRequiredModal = ({ show, onClose }) => {
  const navigate = useNavigate();

  const handlelogin = () => {
    onClose && onClose();
    // redirect to your subscription route
    navigate("/login");
  };
  const handlesignup = () => {
    onClose && onClose();
    // redirect to your subscription route
    navigate("/registration");
  };

  return (
    <Modal
      show={show}
      onHide={onClose}
      centered
      backdrop="static"
      dialogClassName="custom-modal logout-modal subscription-action-modal"
    >
      <Modal.Header>
        <h5 className="modal-title">Login Required!</h5>
        <Button className="close-btn" onClick={onClose}>
          <FiX size={24} />
        </Button>
      </Modal.Header>

      <Modal.Body>
        <div className="action-content text-center mt-1">
          You’ve reached your free salary lookup limit.

          <p>
            Please log in or create an account to continue exploring salary
            insights without limits.
          </p>
        </div>
         <div className="actions">
          <Button className="btn btn-secondary" onClick={handlelogin}>
            Log In
          </Button>
          <Button className="btn btn-primary" onClick={handlesignup} >
            Sign Up
          </Button>
        </div>
      </Modal.Body>

    </Modal>
  );
};

export default LoginRequiredModal;
